// extracted by mini-css-extract-plugin
export default {"wrapper":"SimCardManage_wrapper__xKU+a","headerActions":"SimCardManage_headerActions__DSeRp"};